const { REACT_APP_VIDEO_SDK_URL } = process.env

export const buildMeetUrl = ({
    meetVersion = 0,
    topic,
    zoomToken,
    widgetToken,
    name,
    courseName,
    _classId,
}: {
    meetVersion?: number
    topic: string
    zoomToken: string
    widgetToken: string
    name: string
    courseName: string
    _classId: string
}) => {
    const baseUrl = meetVersion === 0 ? REACT_APP_VIDEO_SDK_URL : REACT_APP_VIDEO_SDK_URL.replace('video.', 'meet.')

    return `${baseUrl}/meeting?${new URLSearchParams({
        topic,
        zoomToken,
        widgetToken,
        name,
        courseName,
        _classId,
    }).toString()}`
}
